import styled from 'styled-components'

export const DescriptionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
`

export const ReportCardsArea = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;

  button::after {
    z-index: 0;
  }
`
